import { render, staticRenderFns } from "./BusinessItemList.vue?vue&type=template&id=255a07f4"
import script from "./BusinessItemList.vue?vue&type=script&lang=js"
export * from "./BusinessItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports